import * as React from "react";

const CatalogIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      stroke="#414651"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M20.2 21c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C21 20.62 21 20.48 21 20.2V9.8c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218C20.62 9 20.48 9 20.2 9h-2.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C17 9.38 17 9.52 17 9.8v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C16.62 13 16.48 13 16.2 13h-2.4c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C13 13.38 13 13.52 13 13.8v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C12.62 17 12.48 17 12.2 17H9.8c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218C9 17.38 9 17.52 9 17.8v2.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218C9.38 21 9.52 21 9.8 21zM9 5.8c0-.28 0-.42.055-.527a.5.5 0 0 1 .218-.218C9.38 5 9.52 5 9.8 5h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219C13 5.38 13 5.52 13 5.8v2.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C12.62 9 12.48 9 12.2 9H9.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C9 8.62 9 8.48 9 8.2zM2 11.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C2.38 11 2.52 11 2.8 11h2.4c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218C6 11.38 6 11.52 6 11.8v2.4c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C5.62 15 5.48 15 5.2 15H2.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.219-.218C2 14.62 2 14.48 2 14.2zM1 1.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C1.38 1 1.52 1 1.8 1h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219C5 1.38 5 1.52 5 1.8v2.4c0 .28 0 .42-.054.527a.5.5 0 0 1-.219.218C4.62 5 4.48 5 4.2 5H1.8c-.28 0-.42 0-.527-.054a.5.5 0 0 1-.218-.219C1 4.62 1 4.48 1 4.2z"
    ></path>
  </svg>
);

export default CatalogIcon;
